import React, { useState } from "react"; 
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import BasePopup from "../../../Components/Base/BasePopup";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const RotogramaViagemRelatorioPopup = (props: any) => {
    const [relatorio, setRelatorio] = useState<any>({});
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    
            
    const [usuario, setUsuario] = useState<any | null>(() => {
        const usuario = localStorage.getItem("user");
        return usuario ? JSON.parse(usuario) : [];
    });

    async function gerarAsync()
    {
        if (relatorio.viagem_id == null || relatorio.viagem_id <= 0) {
            enqueueSnackbar('Informe uma viagem válido.', {variant: 'warning'});
            return;
        }
        
        navigate(`/rotogramaReport/${relatorio.viagem_id}`);
        window.location.reload();
    }

    return (
        <BasePopup
            height="470px"
            size={'md'}
            buttonTitle="Gerar"
            title="Rotograma"
            isOpen={props.isOpen}
            onClose={props.onClose}
            onClickFirstButtonPopupCallback={gerarAsync}
            isPesquisa='false'
            confirmClose={false}>
            <span className="row">
                <TextFieldComponent 
                    label="Número Viagem"
                    divClassName="col-lg-6 col-md-6 col-sm-6 col-6"
                    model={relatorio}
                    field="viagem_id" />
            </span>
        </BasePopup>
    );
}

export default RotogramaViagemRelatorioPopup;

